(ns rothko.theme.sandi.button
  (:refer-clojure :exclude [rem])
  (:require [garden.color :refer [darken lighten]]
            [garden.units :refer [percent rem]]
            [rothko.styles.link :as link-styles]
            [rothko.theme.sandi.colours :refer [colours]]))

(def orange (:orange colours))
(def white (:white colours))

(def default
  {:border-style :solid
   :border-width (rem 0.2)
   :fill :currentColor})

(def main
  {:primary
   (merge
    default
    {:background-color orange
     :background-color--disabled (lighten orange 15)
     :background-color--hover (lighten orange 5)
     :border-color orange
     :border-color--disabled (lighten orange 15)
     :border-color--hover (lighten orange 5)
     :color white})

   :secondary
   (merge
    default
    {:background-color :transparent
     :background-color--hover (merge orange {:alpha 0.1})
     :background-color--disabled :transparent
     :border-color orange
     :border-color--disabled (lighten orange 15)
     :color orange
     :color--disabled (lighten orange 15)})

   :link
   (merge
    link-styles/default-link-style
    {:padding 0
     :min-height 0
     :min-width 0
     :font-size :inherit
     :color--hover (darken orange 15)
     :color--disabled (lighten orange 15)})

   :invisible
   {:background-color :transparent
    :padding 0
    :min-height 0
    :min-width 0
    :font-size :inherit
    :outline :none}

   :no-outline
   {:outline :none}

   :full-width
   {:width (percent 100)}})
